import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup6MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup6MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup6MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup6MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup6MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup6MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup6MasterReference } =
  verificationGroup6MasterReferenceSlice.actions;

export default verificationGroup6MasterReferenceSlice.reducer;
